// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1dapa","messages":"Chat_messages__f100e","dateDivider":"Chat_dateDivider__7nKNv"};